export const Process = () => {
  return (
    <section className="landing-process" id="process">
      <div className="process-container">
        <h2 className="process-title">¿Cómo funciona el portal?</h2>
        <p className="process-subtitle">
          Un flujo sencillo y transparente para gestionar su facturación
        </p>

        <div className="process-steps">
          <div className="process-step">
            <div className="step-circle">1</div>
            <h3>Regístrese</h3>
            <p>
              Complete su información fiscal y datos de contacto de manera
              segura.
            </p>
          </div>

          <div className="process-step">
            <div className="step-circle">2</div>
            <h3>Cargue sus facturas</h3>
            <p>Suba sus facturas en PDF y XML con validaciones automáticas.</p>
          </div>

          <div className="process-step">
            <div className="step-circle">3</div>
            <h3>Dé seguimiento</h3>
            <p>Consulte el estatus de revisión y aprobación en tiempo real.</p>
          </div>

          <div className="process-step">
            <div className="step-circle">4</div>
            <h3>Reciba sus pagos</h3>
            <p>
              Visualice fechas programadas y pagos realizados con total
              claridad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
